module.exports = __webpack_public_path__ + "media/images/lb/782-8fda1abdf3b9a330d2777727e47d7103.svg";